export default __webpack_public_path__ + "static/media/103.75b19b88.jpg";